import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useCanSeeTmBackedComplianceScreen } from "./-components/is-compliance-enabled";

/** Legacy filter route — resolved cases live under /compliance/closed. */
export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance/approved",
)({
  component: ComplianceApprovedRedirect,
});

function ComplianceApprovedRedirect() {
  const tmBackedCompliance = useCanSeeTmBackedComplianceScreen();
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({
      to: tmBackedCompliance ? "/compliance/closed" : "/compliance",
      replace: true,
    });
  }, [navigate, tmBackedCompliance]);
  return null;
}
